import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useBusinessObjectivesForApiNames } from '../../../hooks/useBusinessObjectives';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import BusinessObjectivesFeatures from './BusinessObjectivesFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductBusinessObjectives = ({
  apiName,
  collapsibleBusinessObjectives = false
}) => {
  var _BO$features;
  const {
    businessObjectives: BOArray,
    loading
  } = useBusinessObjectivesForApiNames({
    highlightedProducts: [apiName]
  });
  const BO = BOArray.find(bo => bo.productApiName === apiName);
  const features = (BO === null || BO === void 0 || (_BO$features = BO.features) === null || _BO$features === void 0 ? void 0 : _BO$features.filter(feature => !feature.hideFromLang)) || [];
  const hasFeatures = features.length > 0;
  if (collapsibleBusinessObjectives) {
    return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: loading,
      heights: [48, 48],
      widths: ['100%', '100%'],
      children: /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "800",
        marginBlockEnd: "700",
        children: hasFeatures ? /*#__PURE__*/_jsx(AccordionItem, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.businessObjectives.seeDetails"
          }),
          renderContent: () => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: `productTile.${apiName}.businessObjectives.lowerTierPlus`
            }), /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
              features: features
            })]
          })
        }, apiName) : null
      })
    });
  }
  return /*#__PURE__*/_jsxs(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      paddingBlockStart: "800",
      "data-selenium-id": "biz-objectives-1",
      children: hasFeatures ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `productTile.${apiName}.businessObjectives.lowerTierPlus`
      }) : null
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      "data-selenium-id": "biz-objectives-2",
      marginBlockEnd: "700",
      children: hasFeatures ? /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          features: features
        })
      }) : null
    })]
  });
};
export default ProductBusinessObjectives;